<template>
  <div class="wallet">
    <Modal
      :active="active"
      name="WalletModal"
      closable
      @close.prevent="$emit('close')"
    >
      <div class="wallet__container">
        <div class="wallet__header text-left">
          <span class="header__title" v-html="localizedText.title"></span>
          <Button
            variant="clear"
            size="lg"
            shape="square"
            iconLeft="close"
            class="header__button"
            @click="$emit('close')"
            mobile
          ></Button>
        </div>
        <div class="wallet__placeholder"></div>
        <div class="wallet__balance">
          <div class="balance__coins">
            <img :src="coinLg" />{{coins}}
          </div>
          <div class="balance__link">
            <Link
              variant="primary"
              size="sm"
              iconLeft="shopping-bag"
              :text="localizedText.buy"
              @click="$emit('buy')"
            ></Link>
          </div>
        </div>
        <div class="wallet__divider"></div>
        <div class="wallet__history text-left">
          <div
            v-for="(day, i) in days"
            :key="i"
            class="history__day"
          >
            <div class="day__date" v-html="day.date"></div>
            <div
              v-for="(entry, j) in day.items"
              :key="j"
              class="day__entry"
            >
              <div
                class="entry__img"
                :class="{ 'cursor-pointer': entry.link, 'entry__img_icon': entry.icon }"
                :style="{'background-image': `url(${entry.img})`}"
                @click.stop="onLink(entry.link)"
              >
                <Icon v-if="entry.icon" :name="entry.icon" size="l" />
              </div>
              <div class="entry__text">
                <div
                  class="entry__title"
                  :class="{ 'cursor-pointer': entry.link, 'entry__title_link': entry.link }"
                  v-html="entry.title"
                  :title="entry.title"
                  @click.stop="onLink(entry.link)"
                ></div>
                <div class="entry__type" v-html="entry.type"></div>
              </div>
              <div class="entry__coins">
                <img :src="coinSm" />{{formatCoins(entry.coins)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@rr-component-library/modal/src/main';
import Button from '@rr-component-library/button/src/main';
import Link from '@rr-component-library/link/src/main';
import CoinLg from '../assets/img/coin-40.png';
import CoinSm from '../assets/img/coin-24.png';

export default {
  name: 'Wallet',
  designVersion: '1.0.0',
  components: {
    Modal,
    Button,
    Link,
  },
  props: {
    active: Boolean,
    localizedText: Object,
    coins: Number,
    days: Array,
  },
  data() {
    return {
      coinLg: CoinLg,
      coinSm: CoinSm,
    };
  },
  methods: {
    onLink(link) {
      if (!link) return;
      window.location.href = link;
    },
    formatCoins(value) {
      if (value > 0) return `+${value}`;
      return value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './Wallet';
</style>
